import { toastController } from '@ionic/vue';
import { type I18n } from 'vue-i18n';

// Store the i18n instance
let i18nInstance: I18n | null = null;

// Function to set the i18n instance (call this once from main.ts)
export function setI18nInstance(instance: I18n) {
  i18nInstance = instance;
}

// Function to get translation
function getTranslation(key: string, fallback: string): string {
  if (i18nInstance) {
    return i18nInstance.global.t(key);
  }
  return fallback;
}

export async function featureNotAvailable() {
  const message = getTranslation(
    'featureNotAvailable', 
    'Det här är inte tillgängligt i denna testversion.'
  );
  
  const toast = await toastController.create({
    message,
    duration: 2000,
    position: 'bottom',
  });
  await toast.present();
}

export function clamp(n: number, min: number, max: number) {
  return Math.min(Math.max(n, min), max);
}